// extracted by mini-css-extract-plugin
export var actionButton = "_8q-1";
export var actionButtons = "_8q-2";
export var actions = "_8q-0";
export var aiUnread = "_8q-10";
export var alignCenter = "_8q-h";
export var backWrapper = "_8q-3";
export var cellContainer = "_8q-4";
export var checkboxContainer = "_8q-5";
export var contentContainer = "_8q-6";
export var contentHeader = "_8q-8";
export var conversationsTableWrapper = "_8q-s";
export var draftReplyBadgeContainer = "_8q-m";
export var dropdownItem = "_8q-b";
export var dropdownItemsContainer = "_8q-a";
export var dropdownTitle = "_8q-c";
export var errorIcon = "_8q-7";
export var filter = "_8q-d";
export var gray = "_8q-i";
export var headerActionButtons = "_8q-e";
export var headerCheckboxContainer = "_8q-f";
export var icon = "_8q-j";
export var menuContainer = "_8q-k";
export var noMoreTicketsIcon = "_8q-12";
export var noMoreTicketsSubText = "_8q-13";
export var oneLine = "_8q-l";
export var optionsButton = "_8q-n";
export var plus = "_8q-o";
export var portalButtonsWrapper = "_8q-g";
export var red = "_8q-p";
export var scrolledTop = "_8q-9";
export var search = "_8q-q";
export var selectedConversationsCount = "_8q-r";
export var spinner = "_8q-t";
export var strong = "_8q-u";
export var summaryCell = "_8q-v";
export var tableContainer = "_8q-11";
export var tagContainer = "_8q-w";
export var threeDots = "_8q-x";
export var twoLines = "_8q-y";
export var unread = "_8q-z";